import React from "react";
import Main from "../components/Main";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import StickyPayment from "../components/StickyPayment";
import "../assets/styles/Main.scss";
import NavbarPayment from "../components/NavbarPayment";

const PaymentLayout = ({ children }) => {
  return (
    <div className="site-wrap">
      <StickyPayment>
        <NavbarPayment />
      </StickyPayment>
      <Main>{children}</Main>

      <Footer />
    </div>
  );
};

export default PaymentLayout;
